// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3otTu","inner":"Footer_inner__2WrQR"};